import React from "react";
import Navbar from "./global-components/navbar";
import PageHeader from "./global-components/page-header";
import ContactInfo from "./section-components/contact-info";
import CareersInfo from "./section-components/careers-info";
import Map from "./section-components/map";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";

const CareersV1 = () => {
  return (
    <div>
      <Navbar />
      <PageHeader headertitle="Careers" subheader="Careers" Img="24.webp" />
      {/* <ContactForm /> */}

      <CareersInfo />
      {/* <Map /> */}
      {/* <CallToActionV1 /> */}
      <Footer />
    </div>
  );
};

export default CareersV1;
